import DateAdapter from '@src/utils/DateAdapter'
import NotificacionId from './NotificacionId'
import AREAS from './areas'

const AREAS_MAPPING = {
  armeria: AREAS.ARMERIA,
  equipamiento: AREAS.EQUIPAMIENTO,
  ifcsp: AREAS.IFCSP,
  desarrollo_policial: AREAS.DESARROLLO_POLICIAL,
  enlace_c3: AREAS.ENLACE_C3,
  recursos_humanos: AREAS.RECURSOS_HUMANOS,
  registro_personal: AREAS.REGISTRO_PERSONAL,
  enlace_comisaria: AREAS.ENLACE_COMISARIA,
  ejecutivo: AREAS.EJECUTIVO,
}

export default class Notificacion {
  constructor() {
    this.id = null
    this.responsable = ''
    this.afectado = ''
    this.titulo = ''
    this.mensaje = ''
    this.prioridad = ''
    this.categoria = ''
    this.fecha = null
    this.desarrollo_policial = ''
    this.enlace_c3 = ''
    this.ejecutivo = ''
    this.equipamiento = ''
    this.ifcsp = ''
    this.recursos_humanos = ''
    this.registro_personal = ''
    this.enlace_comisaria = ''
    this.armeria = ''
  }

  static fromDto(notificacionDto) {
    const notificacion = new Notificacion()

    notificacion.id = new NotificacionId(
      notificacionDto.idNotificacion,
      notificacionDto.fk_idPersonalResponsable,
      notificacionDto.fk_idPersonalAfectado
    ).value
    notificacion.responsable = notificacionDto.fk_idPersonalResponsable
    notificacion.afectado = notificacionDto.fk_idPersonalAfectado
    notificacion.titulo = notificacionDto.título
    notificacion.mensaje = notificacionDto.mensaje
    notificacion.fecha = new DateAdapter(notificacionDto.fechaCreacion, 'YYYY-MM-DDTHH:mm:ss').toHumanReadable()
    notificacion.prioridad = notificacionDto.prioridad
    notificacion.categoria = notificacionDto.categoría
    notificacion.armeria = notificacionDto.armeria
    notificacion.equipamiento = notificacionDto.equipamiento
    notificacion.ifcsp = notificacionDto.ifcsp
    notificacion.desarrollo_policial = notificacionDto.desarrollo_policial
    notificacion.enlace_c3 = notificacionDto.enlace_c3
    notificacion.recursos_humanos = notificacionDto.recursos_humanos
    notificacion.registro_personal = notificacionDto.registro_personal
    notificacion.enlace_comisaria = notificacionDto.enlace_comisaria
    notificacion.ejecutivo = notificacionDto.ejecutivo
    return notificacion
  }
}
